import { useState } from 'react';

// On-brand palette (teal / navy family) for deterministic lettermark tiles.
const PALETTE = ['#00A79D', '#1A3A5F', '#00857D', '#2C5578', '#0E7C74', '#3B6E8F', '#146A63'];

const initials = (name) => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

const colorFor = (name) => {
  let h = 0;
  for (let i = 0; i < (name || '').length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
};

export const Lettermark = ({ name, className = 'h-9 w-9 text-sm rounded-md' }) => (
  <span
    className={`inline-flex items-center justify-center font-heading font-bold text-white shrink-0 ${className}`}
    style={{ backgroundColor: colorFor(name) }}
    aria-label={name}
    data-testid="lettermark"
  >
    {initials(name)}
  </span>
);

// Renders the supplier logo, falling back to a lettermark tile if there is no
// logo OR the logo image fails to load.
export const LogoOrMark = ({ logo, name, imgClassName = 'h-9 w-auto max-w-[140px] object-contain', markClassName }) => {
  const [failed, setFailed] = useState(false);
  if (logo && !failed) {
    return <img src={logo} alt={name} className={imgClassName} onError={() => setFailed(true)} />;
  }
  return <Lettermark name={name} className={markClassName} />;
};
